import React from 'react';
import styled from 'styled-components';
import { useAccordionState, useAccordionDispatch } from './AccordionProvider';
import { ChevronUp } from 'pcln-icons';
import { Flex, IconButton } from 'pcln-design-system';
const TriggerContainer = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "AccordionTrigger__TriggerContainer",
  componentId: "sc-oom4ra-0"
})(["line-height:", "px;cursor:pointer;"], ({
  size
}) => size);
const ChevronButton = /*#__PURE__*/styled(IconButton).withConfig({
  displayName: "AccordionTrigger__ChevronButton",
  componentId: "sc-oom4ra-1"
})(["", " ", ""], ({
  shouldAnimate
}) => shouldAnimate ? 'transition: transform 0.4s;' : null, ({
  open
}) => open ? null : 'transform: rotate(180deg);');
const StyledFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "AccordionTrigger__StyledFlex",
  componentId: "sc-oom4ra-2"
})(["flex:1;"]);
const AccordionTrigger = ({
  children,
  size = 24,
  color = 'text',
  iconMR = 2,
  containerPadding = 2,
  hideIcon = false,
  rightIcon = false,
  onClose,
  onOpen,
  ...props
}) => {
  const {
    open,
    shouldAnimate
  } = useAccordionState();
  const dispatch = useAccordionDispatch();
  function onClick(e) {
    dispatch('toggle');
    if (open && onClose) {
      onClose(e);
    } else if (!open && onOpen) {
      onOpen(e);
    }
  }
  const chevronIcon = React.createElement(ChevronButton, {
    ...props,
    mr: iconMR,
    icon: React.createElement(ChevronUp, {
      size: size,
      color: color
    }),
    open: open,
    shouldAnimate: shouldAnimate,
    "aria-label": 'Toggle accordion state',
    "aria-expanded": !!open
  });
  const showLeftIcon = !hideIcon && !rightIcon;
  const showRightIcon = !hideIcon && rightIcon;
  const renderChildren = showRightIcon ? React.createElement(StyledFlex, {
    alignItems: 'center'
  }, children) : children;
  return React.createElement(TriggerContainer, {
    "data-testid": 'trigger-container',
    alignItems: 'center',
    onClick: onClick,
    p: containerPadding
  }, showLeftIcon && chevronIcon, renderChildren, showRightIcon && chevronIcon);
};
export default AccordionTrigger;